<template>
    <div>
        <app-contratacoes
            :contratacoes="contratacoes"
            :pnlVencimentos="pnlVencimentos"
            v-show="mostrarContratacoes"
            @filtrar="filtrar($event)"
            :rowClass="rowClass"
        >
            <template slot="filtros">
                <contratacoes-filtros
                    :servicos="obterServicos()"
                    perfil="gestor"
                    :filtros="filtros"
                    @atualizarFiltros="atualizarFiltros($event)"
                ></contratacoes-filtros>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('GEST-CONT-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharContratacao(data.codContratacao)"
                    ></i>
                </span>
            </template>
        </app-contratacoes>
        <router-view></router-view>
    </div>
</template>

<script>
import ContratacoesServicos from './ContratacoesServicos'
import Contratacoes from '@/app/credenciados/componentes/contratacoes/Contratacoes'
import ContratacoesFiltros from '@/app/credenciados/componentes/contratacoes/ContratacoesFiltros'

export default {
    data() {
        return {
            contratacoes: [],
            pnlVencimentos: {},
            periodo: 0,
            filtros: {
                unidade: -1,
                gestor: -1,
                situacao: -1,
                dataAte: new Date(new Date().getFullYear(), 11, 31),
                dataDe: new Date(new Date().getFullYear(), 0, 1)
            }
        }
    },
    methods: {
        obterContratacoes() {
            this.$store.dispatch('addRequest')
            let filtrosDto = {
                unidade: this.filtros.unidade,
                gestor: this.filtros.gestor,
                situacao: this.filtros.situacao,
                dataDe: this.filtros.dataDe
                    ? this.$moment(this.filtros.dataDe).format('YYYY-MM-DD')
                    : null,
                dataAte: this.filtros.dataAte
                    ? this.$moment(this.filtros.dataAte).format('YYYY-MM-DD')
                    : null,
                periodo: this.periodo
            }
            ContratacoesServicos.obterTodas(filtrosDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.contratacoes = response.data.contratacoes
                        this.pnlVencimentos = response.data.pnlVencimentos
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        detalharContratacao(id) {
            this.$router.push({
                name: `Gestores_Contratacoes_Detalhar`,
                params: {
                    contratacaoId: id
                }
            })
        },

        filtrar(periodo) {
            this.periodo = periodo
            this.obterContratacoes()
        },

        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.prazoCriticoAditivo) return 'table-danger'
        },

        obterServicos() {
            return ContratacoesServicos
        },

        atualizarFiltros(dados) {
            this.filtros = {
                unidade: dados.unidade,
                gestor: dados.gestor,
                situacao: dados.situacao,
                dataAte: dados.dataAte,
                dataDe: dados.dataDe
            }
            this.obterContratacoes()
        }
    },

    created() {
        this.obterContratacoes()
    },

    computed: {
        mostrarContratacoes() {
            return this.$route.name === 'Gestores_Contratacoes'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Gestores_Contratacoes') {
                if (this.$store.getters.recarregar) {
                    this.obterContratacoes()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        AppContratacoes: Contratacoes,
        ContratacoesFiltros
    }
}
</script>
